import { render } from "./SkillBoard.vue?vue&type=template&id=3979b582&scoped=true"
import script from "./SkillBoard.vue?vue&type=script&lang=js"
export * from "./SkillBoard.vue?vue&type=script&lang=js"

import "./SkillBoard.vue?vue&type=style&index=0&id=3979b582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3979b582"]])

export default __exports__